import React from 'react';
import { Avatar, Box, IconButton, Typography } from '@mui/material';

import { CloseIcon } from '../../Icons';

interface DefaultArraySelectorItemProps {
  onRemove: () => void,
  imageSrc: string | undefined,
  fullName: string,
  id: string,
  position?: string,
  rank?: string,
}

export const DefaultArraySelectorItem = ({
  onRemove,
  imageSrc,
  fullName,
  position,
  rank,
  id,
}: DefaultArraySelectorItemProps) => {

  return (
    <Box
      sx={{
        marginBottom: '21px',
      }}
    >
      <Box sx={{
        position: 'relative',
        '&:hover .closeIconButton': {
          display: 'flex',
        }
      }}>
        <IconButton
          className="closeIconButton"
          onClick={onRemove}
          sx={{
            display: 'none',
            position: 'absolute',
            right: '-10px',
            top: '-10px',
            zIndex: 1,
            width: '24px',
            height: '24px',
            borderRadius: '12px',
            backgroundColor: 'white',
            color: '#4F4F4F',
            fontSize: '18px',
            boxShadow: 'rgba(41, 66, 90, 0.12) 0px 4px 16px 0px',

            '&:active': {
              backgroundColor: '#F3F3F3',
              color: '#676767',
              boxShadow: 'none',
            }
          }}
          disableRipple>
          <CloseIcon fontSize="inherit"/>
        </IconButton>
        <Avatar
          src={imageSrc}
          sx={{
            width: 112,
            height: 112,
            borderRadius: '16px',
            position: 'relative'
          }} />
        {
          position ? (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              width: '100%',
              height: '25px',
              backgroundColor: '#F3F3F3',
              bottom: 0,
              borderBottomLeftRadius: '16px',
              borderBottomRightRadius: '16px',

            }}>
              <Typography sx={{
                color: '#080808',
                fontWeight: '500',
                fontSize: '12px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '114px',
                textAlign: 'center'
              }}>
                {position}
              </Typography>
            </Box>
          ) : null
        }
      </Box>

      <Typography sx={{
        color: '#1F1F1F',
        fontWeight: '600',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '114px',
        marginTop: '5px',
      }}>
        {fullName}
      </Typography>
      <Typography sx={{
        color: '#4F4F4F',
        fontWeight: '400',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '114px',
      }}>
        {'ID '}{id}
      </Typography>
      {
        rank ? (<Typography sx={{
          color: '#4F4F4F',
          fontWeight: '400',
          fontSize: '14px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '114px',
          textAlign: 'center'
        }}>
          {rank}
        </Typography>) : null
      }
    </Box>
  );
};
